import PersonaUpdate from './PersonaUpdate'
export {PersonaUpdate}
export default PersonaUpdate
